// src/components/TeamSection.jsx
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaShareAlt } from "react-icons/fa";
import { motion } from "framer-motion"; 
import "./TeamSection.css";

import member1 from "../assets/founder-1.jpeg";
import member2 from "../assets/team-11.jpeg";


const teamMembers = [
  {
    id: 1,
    name: "Masood Khan ",
    role: "Founder",
    image: member1,
    direction: "left",
  },
  {
    id: 2,
    name: "Mohammed Taha ",
    role: "Account Manager",
    image: member2,
    direction: "bottom",
  },
 
];

const variants = {
  hidden: (direction) => {
    switch (direction) {
      case "left":
        return { opacity: 0, x: -100 };
      case "right":
        return { opacity: 0, x: 100 };
      case "bottom":
        return { opacity: 0, y: 100 };
      default:
        return { opacity: 0 };
    }
  },
  visible: { opacity: 1, x: 0, y: 0, transition: { duration: 0.8 } },
};

const TeamSection = () => {
  return (
    <section className="team-section py-5">
      <Container>
        <div className="text-center mb-5">
          <span className="expert-badge">OUR EXPERT</span>
          <h2 className="fw-bold mt-3">The Specialists in <br/>Project Management Services </h2>
        </div>

        <Row className="justify-content-center">
          {teamMembers.map((member) => (
            <Col md={4} sm={6} key={member.id} className="mb-4">
              <motion.div
                custom={member.direction}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }} // ✅ animate every time on view
                variants={variants}
              >
                <Card className="team-card shadow-sm border-0">
                  <div className="image-wrapper">
                    <Card.Img
                      variant="top"
                      src={member.image}
                      alt={member.name}
                      className="team-img"
                    />
                    <div className="overlay1"></div>
                  </div>

                  <Card.Body className="text-center">
                    <h5 className="fw-bold mb-1">{member.name}</h5>
                    <p className="text-muted">{member.role}</p>
                    <div className="share-icon">
                      <FaShareAlt />
                    </div>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TeamSection;
